import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
    agree: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.agree) {
      alert('يرجى الموافقة على الشروط والأحكام');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('service', formData.service);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d6in60hbfjp31emak9h0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: '',
          agree: false,
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[350px] flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/293dc779727688703677d6b63bc0cea7.jpg"
            alt="تواصل معنا"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/75 to-navy/85"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10 text-center">
          <div className="flex items-center justify-center gap-2 text-white/80 text-sm mb-6">
            <Link to="/" className="hover:text-primary transition-all-300">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line"></i>
            <span className="text-primary">تواصل معنا</span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
            تواصل <span className="text-primary">معنا</span>
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            نحن هنا للإجابة على استفساراتك وتقديم أفضل الحلول الأمنية لك
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24">
        <div className="container mx-auto px-6">
          <div className="grid lg:grid-cols-5 gap-12">
            {/* Left Side - Form */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-3xl p-10 shadow-xl border border-gray-medium/10">
                <h2 className="text-3xl font-bold text-navy-light mb-6">
                  أرسل لنا رسالة
                </h2>
                <p className="text-gray-dark mb-8">
                  املأ النموذج وسنتواصل معك في أقرب وقت ممكن
                </p>

                <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
                  {/* Name */}
                  <div className="mb-6">
                    <label htmlFor="name" className="block text-navy-light font-semibold mb-2">
                      الاسم الكامل
                    </label>
                    <div className="relative">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full h-14 px-5 pr-12 border border-gray-medium/30 rounded-lg focus:border-primary focus:outline-none transition-all-300 text-sm"
                        placeholder="أدخل اسمك الكامل"
                      />
                      <i className="ri-user-line absolute right-4 top-1/2 -translate-y-1/2 text-gray-dark"></i>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="mb-6">
                    <label htmlFor="email" className="block text-navy-light font-semibold mb-2">
                      البريد الإلكتروني
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full h-14 px-5 pr-12 border border-gray-medium/30 rounded-lg focus:border-primary focus:outline-none transition-all-300 text-sm"
                        placeholder="example@email.com"
                      />
                      <i className="ri-mail-line absolute right-4 top-1/2 -translate-y-1/2 text-gray-dark"></i>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="mb-6">
                    <label htmlFor="phone" className="block text-navy-light font-semibold mb-2">
                      رقم الهاتف
                    </label>
                    <div className="relative">
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        className="w-full h-14 px-5 pr-12 border border-gray-medium/30 rounded-lg focus:border-primary focus:outline-none transition-all-300 text-sm"
                        placeholder="+966 50 000 0000"
                      />
                      <i className="ri-phone-line absolute right-4 top-1/2 -translate-y-1/2 text-gray-dark"></i>
                    </div>
                  </div>

                  {/* Service */}
                  <div className="mb-6">
                    <label htmlFor="service" className="block text-navy-light font-semibold mb-2">
                      نوع الخدمة
                    </label>
                    <div className="relative">
                      <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        required
                        className="w-full h-14 px-5 pr-12 border border-gray-medium/30 rounded-lg focus:border-primary focus:outline-none transition-all-300 text-sm appearance-none cursor-pointer"
                      >
                        <option value="">اختر نوع الخدمة</option>
                        <option value="cameras">أنظمة كاميرات المراقبة</option>
                        <option value="access">أنظمة التحكم في الدخول</option>
                        <option value="gates">البوابات الأمنية</option>
                        <option value="alarm">أنظمة الإنذار</option>
                        <option value="network">الشبكات والبنية التحتية</option>
                        <option value="other">أخرى</option>
                      </select>
                      <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-gray-dark pointer-events-none"></i>
                    </div>
                  </div>

                  {/* Message */}
                  <div className="mb-6">
                    <label htmlFor="message" className="block text-navy-light font-semibold mb-2">
                      الرسالة
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-5 py-4 border border-gray-medium/30 rounded-lg focus:border-primary focus:outline-none transition-all-300 text-sm resize-none"
                      placeholder="اكتب رسالتك هنا... (حد أقصى 500 حرف)"
                    ></textarea>
                    <div className="text-left text-xs text-gray-dark mt-1">
                      {formData.message.length}/500
                    </div>
                  </div>

                  {/* Agreement */}
                  <div className="mb-6">
                    <label className="flex items-start gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        name="agree"
                        checked={formData.agree}
                        onChange={handleChange}
                        required
                        className="mt-1 w-5 h-5 text-primary border-gray-medium/30 rounded focus:ring-primary cursor-pointer"
                      />
                      <span className="text-sm text-gray-dark">
                        أوافق على الشروط والأحكام وسياسة الخصوصية
                      </span>
                    </label>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full h-14 bg-primary text-white text-base font-semibold rounded-lg hover:bg-primary-dark transition-all-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                  >
                    {isSubmitting ? 'جاري الإرسال...' : 'إرسال الرسالة'}
                  </button>

                  {/* Status Messages */}
                  {submitStatus === 'success' && (
                    <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">
                      تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.
                    </div>
                  )}
                  {submitStatus === 'error' && (
                    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                      حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى.
                    </div>
                  )}
                </form>
              </div>
            </div>

            {/* Right Side - Map & Info */}
            <div className="lg:col-span-3">
              {/* Map */}
              <div className="rounded-3xl overflow-hidden shadow-xl mb-8 h-[400px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.2!2d46.6753!3d24.7136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjTCsDQyJzQ5LjAiTiA0NsKwNDAnMzEuMSJF!5e0!3m2!1sen!2ssa!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="موقعنا على الخريطة"
                ></iframe>
              </div>

              {/* Contact Info Cards */}
              <div className="grid md:grid-cols-3 gap-6">
                {/* Phone */}
                <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-medium/10 hover:shadow-xl transition-all-300">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary/10 mb-4">
                    <i className="ri-phone-line text-2xl text-primary"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-navy-light mb-2">
                    الهاتف
                  </h3>
                  <a
                    href="tel:+966500000000"
                    className="text-gray-dark hover:text-primary transition-all-300 text-base"
                  >
                    +966 50 000 0000
                  </a>
                </div>

                {/* Email */}
                <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-medium/10 hover:shadow-xl transition-all-300">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary/10 mb-4">
                    <i className="ri-mail-line text-2xl text-primary"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-navy-light mb-2">
                    البريد الإلكتروني
                  </h3>
                  <a
                    href="mailto:info@security-solutions.com"
                    className="text-gray-dark hover:text-primary transition-all-300 text-base break-all"
                  >
                    info@security-solutions.com
                  </a>
                </div>

                {/* Address */}
                <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-medium/10 hover:shadow-xl transition-all-300">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary/10 mb-4">
                    <i className="ri-map-pin-line text-2xl text-primary"></i>
                  </div>
                  <h3 className="text-lg font-semibold text-navy-light mb-2">
                    العنوان
                  </h3>
                  <p className="text-gray-dark text-base leading-relaxed">
                    الرياض، المملكة العربية السعودية
                  </p>
                </div>
              </div>

              {/* Social Media */}
              <div className="mt-8 bg-gradient-to-br from-navy to-navy-light rounded-2xl p-8 text-center">
                <h3 className="text-2xl font-bold text-white mb-4">
                  تابعنا على وسائل التواصل
                </h3>
                <div className="flex items-center justify-center gap-4">
                  {[
                    { icon: 'ri-facebook-fill', url: '#' },
                    { icon: 'ri-twitter-x-fill', url: '#' },
                    { icon: 'ri-linkedin-fill', url: '#' },
                    { icon: 'ri-instagram-line', url: '#' },
                    { icon: 'ri-youtube-fill', url: '#' },
                  ].map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-primary transition-all-300 cursor-pointer"
                    >
                      <i className={`${social.icon} text-xl`}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;